<template>
  <div class="product-edit-container">
    <el-form :model="form" label-width="100px" label-position="left" ref="productFormRef">
      <!-- 1. 基本信息 -->
      <el-card shadow="never" class="box-card">
        <template #header>
          <div class="card-header"><span>基本信息</span></div>
        </template>

        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="商品标题" required>
              <el-input :maxlength="30" v-model="form.spuName" placeholder="请输入商品标题" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 问题3解决：分类接口 + 搜索 -->
            <el-form-item label="产品类目">
              <el-select
                v-model="form.catCode"
                placeholder="请选择或搜索分类"
                filterable
                clearable
                style="width: 100%"
                @change="handleCatChange"
                :loading="catLoading"
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.catCode"
                  :label="item.catName"
                  :value="item.catCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="商品简介" required class="section-item">
          <el-input
            v-model="form.simpleDesc"
            type="textarea"
            :rows="3"
            placeholder="商品简介最少输入10个字符"
            :maxlength="30"
            :minlength="10"
            show-word-limit
          />
        </el-form-item>

        <!-- 问题1解决：使用正常的布局流，移除 margin-top 这种容易引起重叠的操作 -->
        <el-form-item label="商品主图" required class="image-section">
          <div class="image-uploader-wrapper">
            <div class="image-grid">
              <CUpload
                :model-value="form.goodsImgUrlList"
                list-type="image"
                src-type="url"
                accept="image/*"
                :multiple="true"
                :size-limit="10"
                :count-limit="9"
                @change="onCompleteHeaderPic"
              />
            </div>
            <div class="tip">建议 800*1000，最多9张 ({{ form.goodsImgUrlList?.length }}/9)</div>
          </div>
        </el-form-item>

        <el-form-item label="商品详情" required class="image-section">
          <div class="image-uploader-wrapper">
            <div class="image-grid">
              <CUpload
                :model-value="form.goodsDetailUrlList"
                list-type="image"
                src-type="url"
                accept="image/*"
                :multiple="true"
                :size-limit="10"
                :count-limit="10"
                @change="onCompleteDetailPic"
              />
            </div>
            <div class="tip">最多10张 ({{ form.goodsDetailUrlList?.length }}/10)</div>
          </div>
        </el-form-item>
      </el-card>

      <!-- 2. 规格与库存 -->
      <el-card shadow="never" class="box-card mt-20">
        <template #header>
          <div class="card-header"><span>价格与库存</span></div>
        </template>
        <div v-for="(item, idx) in specList" :key="idx">
          <div class="spec-manage-box">
            <div class="spec-header-row">
              <span class="label">规格名称：</span>
              <el-input v-model="item.tempSpecName" :maxlength="10" placeholder="如：净含量" style="width: 240px" />
              <span class="tip-inline">修改名称将更新下方表格列名</span>
              <el-button
                type="primary"
                style="margin-left: 126px"
                v-if="item.isDelete && specList.length > 1"
                @click="deleteSpec(idx)"
              >
                删除
              </el-button>
            </div>

            <div class="spec-values-row">
              <span class="label">规格值：</span>
              <div class="values-list">
                <div v-for="(val, index) in item.tempSpecValues" :key="index" class="spec-value-item">
                  <el-input
                    v-model="item.tempSpecValues[index].name"
                    placeholder="输入规格"
                    oninput="if(value.length > 20) value=value.slice(0, 20)"
                    :maxlength="20"
                    @input="updateSpecValue($event, idx, index)"
                    @blur="handleSpecBlur"
                  />
                  <el-button
                    type="primary"
                    v-if="item.tempSpecValues.length > 1 && !item.tempSpecValues[index].isEdit"
                    @click="deleteSpecValue(idx, index)"
                  >
                    删除
                  </el-button>
                </div>
                <el-button type="primary" v-if="canAddSpecValue(idx)" plain @click="addSpecValue(idx)">
                  添加规格值
                </el-button>
<!--                <el-button type="primary" v-if=" form.skuList.length < 10" plain @click="addSpecValue(idx)">-->
<!--                  添加规格值-->
<!--                </el-button>-->
              </div>
            </div>
          </div>
        </div>
        <el-button type="primary" v-if="specList.length < 2" plain @click="addSpec">创建新规格</el-button>
        <div class="sku-table-wrapper">
          <el-table :data="form.skuList" border stripe>
            <!-- 问题2解决：动态列名由 tempSpecName 决定 -->
            <el-table-column
              :label="specList.length > 0 && specList[0].tempSpecName ? specList[0].tempSpecName : '规格'"
              min-width="150"
            >
              <template #default="{ row }">
                <el-input oninput="if(value.length > 20) value=value.slice(0, 20)" disabled v-model="row.skuName" />
              </template>
            </el-table-column>

            <el-table-column
              :label="specList.length > 1 && specList[1].tempSpecName ? specList[1].tempSpecName : '规格2'"
              min-width="150"
              v-if="specList.length > 1"
            >
              <template #default="{ row }">
                <el-input
                  oninput="if(value.length > 20) value=value.slice(0, 20)"
                  disabled
                  v-model="row.innerSkuName"
                />
              </template>
            </el-table-column>

            <el-table-column label="* 售价" width="150" key="sellingPrice">
              <template #default="{ row }">
                <el-input-number
                  v-model="row.sellingPrice"
                  :precision="2"
                  :min="0"
                  controls-position="right"
                  style="width: 100%"
                />
              </template>
            </el-table-column>
            <el-table-column label="成本价" width="150" key="costPrice">
              <template #default="{ row }">
                <el-input-number
                  v-model="row.costPrice"
                  :precision="2"
                  :min="0"
                  controls-position="right"
                  style="width: 100%"
                />
              </template>
            </el-table-column>
            <el-table-column label="* 库存" width="130" key="stockNum">
              <template #default="{ row }">
                <el-input-number
                  v-model="row.stockNum"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                  style="width: 100%"
                  placeholder="数量"
                />
              </template>
            </el-table-column>
            <el-table-column label="一级分佣比例" width="150" key="firstCommissionRate">
              <template #default="{ row }">
                <el-input-number
                  v-model="row.firstCommissionRate"
                  :precision="2"
                  :min="0"
                  controls-position="right"
                  style="width: 100%"
                />
              </template>
            </el-table-column>
            <el-table-column label="二级分佣比例" width="150" key="secondCommissionRate">
              <template #default="{ row }">
                <el-input-number
                  v-model="row.secondCommissionRate"
                  :precision="2"
                  :min="0"
                  controls-position="right"
                  style="width: 100%"
                  placeholder="比例"
                />
              </template>
            </el-table-column>
            <el-table-column label="SKU编码" min-width="140">
              <template #default="{ row }">
                <el-input disabled v-model="row.skuCode" placeholder="编码" />
              </template>
            </el-table-column>
            <el-table-column label="上架" width="80" align="center">
              <template #default="{ row }">
                <el-switch v-model="row.skuStatus" active-value="grounding" inactive-value="off_shelf" />
              </template>
            </el-table-column>
            <!--            <el-table-column label="操作" width="80" align="center">-->
            <!--              <template #default="{ row, $index }">-->
            <!--                <el-button v-if="showDeleteBtn($index)" link type="danger" @click="removeSpecValue(row, $index)">-->
            <!--                  删除-->
            <!--                </el-button>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
          </el-table>
        </div>
      </el-card>

      <!-- 3. 其他设置 -->
      <!-- 3. 其他设置 -->
      <el-card shadow="never" class="box-card mt-20">
        <el-form-item label="购买限制">
          <el-switch v-model="form.buyLimiter" :active-value="1" :inactive-value="0" />
          <span class="ml-10">{{ form.buyLimiter === 1 ? '已开启限购' : '不限购' }}</span>
          <span v-if="form.buyLimiter === 1" class="limit-box">
            每人
            <span>
              <el-select v-model="form.buyRuleType" placeholder="请选择">
                <el-option label="每日" value="day" />
                <el-option label="每单" value="order_num" />
              </el-select>
            </span>
            限购
            <el-input-number v-model="form.buyRuleValue" :max="100" :min="1" />
            件
          </span>
        </el-form-item>
      </el-card>

      <!-- 4. 发货与售后 -->
      <el-card shadow="never" class="box-card mt-20" style="height: 360px">
        <template #header>
          <div class="card-header"><span>发货与售后</span></div>
        </template>

        <el-form-item label="发货时间">
          预计

          <el-input
            v-model="form.expectedDeliveryHours"
            clearable
            style="width: 120px; margin: 0 8px"
            @input="onInput"
          />
          小时内发货
        </el-form-item>

        <el-form-item label="退货地址" required>
          <div class="address-box">
            <el-form-item label="省市区" required label-width="70px" class="mb-10">
              <el-cascader
                v-model="selectedArea"
                :options="areaOptions"
                :props="{ label: 'label', value: 'value', children: 'children' }"
                placeholder="请选择省市区"
                @change="handleAreaChange"
                style="width: 100%"
                clearable
                filterable
              />
            </el-form-item>
            <el-form-item label="详细地址" required label-width="70px" class="mb-10">
              <el-input v-model="form.returnAddressDetail" placeholder="请输入详细地址" />
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系人" required label-width="70px">
                  <el-input v-model="form.returnContactName" placeholder="请输入联系人" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号" required label-width="70px">
                  <el-input v-model="form.returnContactMobile" placeholder="请输入手机号" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-card>

      <div class="form-footer">
        <el-button size="large" @click="handleCancel">取消</el-button>
        <el-button type="primary" size="large" @click="submitForm">确认提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { _, useCurrentAppInstance, watch,computed } from '@zto/zpage'
import { CUpload } from '@zto/zpage-ui-element/components'
import { cityJson } from './city'

const app = useCurrentAppInstance()
let isEdit = ref(false)
// --- 省市区选择相关 ---
const areaOptions = ref(cityJson)
const selectedArea = ref([])

// 监听区域选择变化
const handleAreaChange = value => {
  if (!value || value.length === 0) {
    form.provinceId = ''
    form.cityId = ''
    form.districtId = ''
    form.provinceName = ''
    form.cityName = ''
    form.districtName = ''
    return
  }

  form.provinceId = String(value[0] || '')
  form.cityId = String(value[1] || '')
  form.districtId = String(value[2] || '')

  // 获取对应的 label
  if (areaOptions.value.length > 0) {
    const province = areaOptions.value.find(item => String(item.value) === form.provinceId)
    form.provinceName = province ? province.label : ''

    if (province && province.children && form.cityId) {
      const city = province.children.find(item => String(item.value) === form.cityId)
      form.cityName = city ? city.label : ''

      if (city && city.children && form.districtId) {
        const district = city.children.find(item => String(item.value) === form.districtId)
        form.districtName = district ? district.label : ''
      }
    }
  }
}

// 控制新增规格显隐
const canAddSpecValue = (idx) => {
  const spec = specList.value[idx]
  if (!spec) return false
  if (!Array.isArray(spec.tempSpecValues)) return false

  return spec.tempSpecValues.length < 10
}

// --- 数据模型 (完全对应后端 SpuInfoCreateReq) ---
// --- 数据模型 (完全对应后端 SpuInfoCreateReq) ---
let form = reactive({
  spuName: '',
  catCode: '',
  catName: '',
  buyLimiter: 0,
  goodsImgUrlList: [],
  goodsDetailUrlList: [],
  simpleDesc: '',
  skuList: [],
  expectedDeliveryHours: undefined, // 默认48小时
  provinceId: '',
  cityId: '',
  districtId: '',
  provinceName: '',
  cityName: '',
  districtName: '',
  returnAddressDetail: '',
  returnContactName: '',
  returnContactMobile: ''
})

// const showDeleteBtn = index => {
//   if (index > form.skuList.length - 1) {
//     return true
//   }
//   return !form.skuList[index].skuCode
// }

// 辅助响应式变量
const categoryList = ref([])
const catLoading = ref(false)

const specList = ref([{ tempSpecName: '', tempSpecValues: [{ name: '默认规格', isEdit: isEdit.value }] }])

const allSpecList = ref([
  [
    {
      rowId: Math.random().toString(36).slice(2),
      skuName: '默认规格',
      skuCode: '',
      innerSkuName: '',
      sellingPrice: undefined,
      costPrice: undefined,
      stockNum: undefined,
      firstCommissionRate: undefined,
      secondCommissionRate: undefined,
      originalSkuPrice: undefined,
      skuStatus: 'grounding'
    }
  ]
])

watch(
  () => allSpecList.value,
  (cur, old) => {
    console.log('======watch====')
    console.log(cur)

    const list = []
    for (let i = 0; i < cur.length; i++) {
      for (let j = 0; j < cur[i].length; j++) {
        list.push(cur[i][j])
      }
    }
    console.log(list.length)
    form.skuList = list
  },
  { deep: true }
)

function getHashQuery() {
  const hash = window.location.hash || ''
  const queryStr = hash.includes('?') ? hash.split('?')[1] : ''
  return new URLSearchParams(queryStr)
}

// --- 逻辑实现 ---

const onInput = val => {
  if (val === '') {
    form.expectedDeliveryHours = null
  } else {
    const num = Number(val)
    if (!Number.isNaN(num)) {
      form.expectedDeliveryHours = Math.min(100, Math.max(1, num))
    }
  }
}

const queryDetail = async () => {
  const params = getHashQuery()
  const id = params.get('id')
  if (id) {
    isEdit.value = true
    const res = await app.request({
      api: 'admin/goods/detail',
      params: {
        spuCode: id
      }
    })
    const newSkuList = (res.skuInfoList || []).map((value, index, array) => {
      return transferSku(value)
    })
    specList.value = parseSkuToSpecConfig(res.specList || [])
    allSpecList.value = groupBySkuNameTo2DArray(newSkuList)

    res.goodsImgUrlList = res.spuDetailDTO.goodsImgList
    res.goodsDetailUrlList = res.spuDetailDTO.detailImgList

    if (res.goodsBuyRuleDTO.ruleValue) {
      res.buyLimiter = 1
      res.buyRuleValue = Number.parseInt(res.goodsBuyRuleDTO.ruleValue)
    }
    res.buyRuleType = res.goodsBuyRuleDTO.ruleType

    // 退货地址信息回显
    // 兼容旧逻辑，如果 returnAddressInfo 存在则优先使用（防止后端结构未完全统一）
    if (res.returnAddressInfo) {
      res.provinceId = res.returnAddressInfo.provinceId
      res.cityId = res.returnAddressInfo.cityId
      res.districtId = res.returnAddressInfo.districtId
      res.provinceName = res.returnAddressInfo.provinceName
      res.cityName = res.returnAddressInfo.cityName
      res.districtName = res.returnAddressInfo.districtName
      res.returnAddressDetail = res.returnAddressInfo.returnAddressDetail
      res.returnContactName = res.returnAddressInfo.returnContactName
      res.returnContactMobile = res.returnAddressInfo.returnContactMobile
    }
    // 注意：如果 res.returnAddressInfo 不存在，而字段直接在 res 根下，
    // 下面的 Object.assign(form, res) 会自动处理赋值，无需手动赋值。

    // 处理省市区回显
    if (res.provinceId && res.cityId && res.districtId) {
      selectedArea.value = [String(res.provinceId), String(res.cityId), String(res.districtId)]
    } else {
      selectedArea.value = []
    }

    Object.assign(form, res)
  }
}
/**
 * 从 SKU 列表逆向解析出规格配置
 * @param {Array} skuList - 输入的 SKU 列表 (包含 specInfoList)
 * @returns {Array} - 解析后的规格配置列表 [{ tempSpecName, tempSpecValues }, ...]
 */
function parseSkuToSpecConfig(specList) {
  if (!Array.isArray(specList)) {
    return []
  }

  return specList.map(item => {
    // 1. 提取规格名称
    const name = item.specName

    // 2. 处理规格值列表
    // 如果 specValueList 存在且是数组，则提取其中的 specValue 字段
    let values = []
    if (Array.isArray(item.specValueList)) {
      values = item.specValueList
        .filter(val => val.specValue !== null && val.specValue !== undefined) // 过滤掉空值
        .map(val => {
          return { name: val.specValue, isEdit: isEdit.value }
        }) // 只保留 specValue 字符串
    }

    // 3. 返回目标格式对象
    return {
      tempSpecName: name,
      tempSpecValues: values
    }
  })
}

function transferSku(sku) {
  const skuInfoList = sku.specInfoList || []
  const skuName = sku.skuName
  const innerNameList = skuInfoList.filter(it => it.specValue !== skuName)
  sku.innerSkuName = innerNameList.length > 0 ? innerNameList[0].specValue : ''
  return sku
}
function handleCancel() {
  ElMessageBox.confirm('确认离开当前页面吗？', '提示', {
    confirmButtonText: '是',
    cancelButtonText: '否',
    type: 'warning'
  })
    .then(() => {
      // 👉 点【确定】
      app.router.close()
    })
    .catch(() => {
      // 👉 点【取消】或关闭
      ElMessage.info('已取消操作')
    })
}

function onCompleteHeaderPic(t) {
  form.goodsImgUrlList = t
}

function onCompleteDetailPic(t) {
  form.goodsDetailUrlList = t
}

// 1. 获取分类 (问题3)
const getCategoryList = async () => {
  catLoading.value = true
  try {
    const res = await app.request({
      api: 'admin/catInfo/list',
      params: { pageSize: 100, pageIndex: 1 }
    })
    categoryList.value = res?.data.filter(item => item.catStatus === 'grounding') || []
  } finally {
    catLoading.value = false
  }
}

const handleCatChange = val => {
  const target = categoryList.value.find(item => item.catCode === val)
  form.catName = target ? target.catName : ''
}
const genRowId = () => Math.random().toString(36).slice(2)
const handleSpecValueChange = () => {
  allSpecList.value = [
    [
      {
        rowId: genRowId(),
        skuName: '默认规格',
        skuCode: '',
        innerSkuName: '',
        sellingPrice: undefined,
        costPrice: undefined,
        stockNum: undefined,
        firstCommissionRate: undefined,
        secondCommissionRate: undefined,
        originalSkuPrice: undefined,
        skuStatus: 'grounding'
      }
    ]
  ]
}
// const deleteSpec = specIndex => {
//   specList.value.splice(specIndex, 1)
//
//
//   let newAllSpecList = []
//   if (specList.value.length === 1) {
//     const tempSpecValues = specList.value[0].tempSpecValues
//     for (let i = 0; i < tempSpecValues.length; i++) {
//       newAllSpecList.push([
//         {
//           rowId: Math.random().toString(36).slice(2),
//           skuName: tempSpecValues[i].name,
//           skuCode: '',
//           innerSkuName: '',
//           sellingPrice: undefined,
//           costPrice: undefined,
//           stockNum: undefined,
//           firstCommissionRate: undefined,
//           secondCommissionRate: undefined,
//           originalSkuPrice: undefined,
//           skuStatus: 'grounding'
//         }
//       ])
//     }
//     allSpecList.value = newAllSpecList
//     // console.log('====删除allSpecList.value:', JSON.stringify(allSpecList.value))
//   }
// }

const buildKey = (skuName, innerSkuName) => {
  return `${skuName || ''}__${innerSkuName || ''}`
}

const deleteSpec = (specIndex) => {
  if (specList.value.length <= 1) {
    // 不允许删除最后一个规格
    return
  }

  // 1. 删除规格
  const removedSpec = specList.value.splice(specIndex, 1)[0]

  // 2. 处理 allSpecList
  if (specIndex === 0) {
    // 删除第一维规格 → 清空每行 skuName，保留 innerSkuName
    allSpecList.value = allSpecList.value.map(row => {
      return row.map(item => ({
        ...item,
        skuName: '',
      }))
    })
  } else if (specIndex === 1) {
    // 删除第二维规格 → 删除 allSpecList 中与规格2相关的行
    // 方式：只保留规格1的 skuName，删除 innerSkuName 对应的所有对象

    const newAllSpecList = []

    specList.value[0].tempSpecValues.forEach((spec1Value, idx) => {
      // 找到原来对应规格1的行
      const baseRow = allSpecList.value[idx] || []

      // 保留第一列（规格1）数据，删除规格2相关列（即长度>1的部分）
      const newRow = baseRow.slice(0, 1).map(item => ({
        ...item,
        innerSkuName: '', // 清空 innerSkuName
      }))

      newAllSpecList.push(newRow)
    })

    allSpecList.value = newAllSpecList
  }

  // 3. 删除规格值列表
  removedSpec.tempSpecValues = []
}
const deleteSpecValue = (comlumIndex, rowIndex) => {
  if (comlumIndex === 0) {
    specList.value[0].tempSpecValues.splice(rowIndex, 1)
    allSpecList.value.splice(rowIndex, 1)
  }
  if (comlumIndex === 1) {
    specList.value[1].tempSpecValues.splice(rowIndex, 1)
    allSpecList.value = allSpecList.value.map(item => {
      return item.filter((val, idx) => {
        return idx !== rowIndex
      })
    })
  }
}
const updateSpecValue = (event, comlumIndex, rowIndex) => {

  if (comlumIndex === 0) {
    allSpecList.value = allSpecList.value.map((item, index, array) => {
      if (index !== rowIndex) return item
      return item.map((val, idx) => {
        val.skuName = event
        return val
      })
    })
  }
  if (comlumIndex === 1) {
    allSpecList.value = allSpecList.value.map((val, idx) => {
      return val.map((item, index) => {
        if (index === rowIndex) {
          item.innerSkuName = event
        }
        return item
      })
    })
  }
}

/**
 * 教研规格不能相同
 */
const handleSpecBlur = () => {
  // 1. 拿到所有规格值（跨规格）
  const allValues = specList.value
    .flatMap(spec => spec.tempSpecValues)
    .map(v => v.name?.trim())
    .filter(Boolean)

  // 2. 判断是否重复
  const set = new Set()
  const duplicates = new Set()

  allValues.forEach(val => {
    if (set.has(val)) {
      duplicates.add(val)
    } else {
      set.add(val)
    }
  })

  // 3. 有重复 → 提示
  if (duplicates.size > 0) {
    ElMessage.warning(`规格值不能重复：${Array.from(duplicates).join('、')}`)
  }
}

const addSpecValue = index => {
  // tempSpecValues.value.push('')

  specList.value[index].tempSpecValues.push({ name: '', isEdit: false })
  addSpecValueChange(index)
}
const addSpecValueChange = index => {
  // index === 0, 增加第一个规格的规格值
  if (index === 0) {
    const specListLength = specList.value.length
    if (specListLength === 1 || (specListLength === 2 && specList.value[1].tempSpecValues.length === 1)) {
      // 没有第二个规格 或者是 有第二个规格 且第二个规格 只有一个规格值
      let innerSkuName = specListLength === 1 ? '' : specList.value[1].tempSpecValues[0].name
      allSpecList.value.push([
        {
          rowId: Math.random().toString(36).slice(2),
          skuName: '',
          skuCode: '',
          innerSkuName,
          sellingPrice: undefined,
          costPrice: undefined,
          stockNum: undefined,
          firstCommissionRate: undefined,
          secondCommissionRate: undefined,
          originalSkuPrice: undefined,
          skuStatus: 'grounding'
        }
      ])
      // console.log('====新增allSpecList.value:', JSON.stringify(allSpecList.value))
    }
    if (specListLength > 1 && specList.value[1].tempSpecValues.length > 1) {
      // 有第二个规格 且第二个规格 的规格值多于1个
      allSpecList.value.push([])
      for (let i = 0; i < specList.value[1].tempSpecValues.length; i++) {
        allSpecList.value[allSpecList.value.length - 1].push({
          rowId: Math.random().toString(36).slice(2),
          skuName: '',
          skuCode: '',
          innerSkuName: specList.value[1].tempSpecValues[i].name,
          sellingPrice: undefined,
          costPrice: undefined,
          stockNum: undefined,
          firstCommissionRate: undefined,
          secondCommissionRate: undefined,
          originalSkuPrice: undefined,
          skuStatus: 'grounding'
        })
      }
    }
  }
  if (index === 1) {
    // index === 1，增加第二个规格的规格值
    for (let i = 0; i < allSpecList.value.length; i++) {
      const skuName = specList.value[0].tempSpecValues[i].name
      allSpecList.value[i].push({
        rowId: Math.random().toString(36).slice(2),
        skuName: skuName || '',
        skuCode: '',
        innerSkuName: '',
        sellingPrice: undefined,
        costPrice: undefined,
        stockNum: undefined,
        firstCommissionRate: undefined,
        secondCommissionRate: undefined,
        originalSkuPrice: undefined,
        skuStatus: 'grounding'
      })
    }
  }
}
const addSpec = () => {
  if (specList.value.length >= 2) return
  specList.value.push({ tempSpecName: '', tempSpecValues: [{ name: '默认规格1', isEdit: false }],isDelete: true })
  allSpecList.value = allSpecList.value.map((item, index) => {
    return item.map((val, idx) => {
      val.innerSkuName = '默认规格1'
      return val
    })
  })
}
/**
 * 将列表按 skuName 分组，返回二维数组
 * 格式: [ [{...}, {...}], [{...}] ]
 *
 * @param {Array} list - 输入列表
 * @returns {Array<Array>} - 二维数组
 */
function groupBySkuNameTo2DArray(list) {
  if (!Array.isArray(list) || list.length === 0) return []

  const map = new Map()

  // 1. 遍历列表，按 skuName 归类到 Map 中
  list.forEach(item => {
    const key = item.skuName
    if (!map.has(key)) {
      map.set(key, [])
    }
    map.get(key).push(item)
  })

  // 2. 直接取出 Map 中的所有 values，即为二维数组
  // 注意：组的顺序取决于 skuName 首次出现的顺序
  return Array.from(map.values())
}

const hasDuplicateSpuName = skuList => {
  const nameSet = new Set()

  for (const item of skuList) {
    const sku = item.skuName + '-' + item.innerSkuName
    if (!sku) continue // 可选：忽略空值

    if (nameSet.has(sku) && nameSet.has(sku)) {
      return true
    }
    nameSet.add(sku)
  }

  return false
}
// 4. 提交数据
const submitForm = async () => {
  // 校验逻辑
  if (!form.spuName) return ElMessage.warning('请输入标题')
  if (!form.simpleDesc || form.simpleDesc.length < 10) {
    return ElMessage.warning('商品简介最少输入10个字符')
  }
  if (!form.goodsImgUrlList.length) return ElMessage.warning('请上传商品主图')
  if (!form.goodsDetailUrlList.length) return ElMessage.warning('请上传商品详情图')

  // 退货地址校验
  if (!form.provinceId || !form.cityId || !form.districtId) {
    return ElMessage.warning('请选择退货地址省市区')
  }
  if (!form.returnAddressDetail) {
    return ElMessage.warning('请输入退货详细地址')
  }
  if (!form.returnContactName) {
    return ElMessage.warning('请输入退货联系人')
  }
  if (!form.returnContactMobile) {
    return ElMessage.warning('请输入退货联系人手机号')
  }

  if (hasDuplicateSpuName(form.skuList)) {
    return ElMessage.warning('sku名称重复,请修改')
  }
  //firstCommissionRate\secondCommissionRate
  // debugger

  if (
    form.skuList.some(s => {
      const inValidateSellPrice = !s.sellingPrice
      return inValidateSellPrice || s.stockNum === undefined || s.stockNum === null
    })
  ) {
    return ElMessage.warning('请填写完整的SKU价格和库存')
  }

  // 验证分佣比例
  const hasInvalidCommission = form.skuList.some((s, index) => {
    const firstRate = Number(s.firstCommissionRate) || 0
    const secondRate = Number(s.secondCommissionRate) || 0
    if (firstRate + secondRate > 100) {
      ElMessage.warning(`第${index + 1}个规格：一级和二级分佣比例总和不能超过100%（当前：${firstRate + secondRate}%）`)
      return true
    }
    return false
  })

  if (hasInvalidCommission) {
    return
  }

  if (form.buyLimiter === 0) {
    form.buyRuleValue = ''
    form.buyRuleType = ''
  }
  // 深度清理准备提交的数据
  const payload = JSON.parse(JSON.stringify(form))
  const specLists = specList.value
  let firstSpecName = specLists[0].tempSpecName
  let secondSpecName = specLists.length > 1 ? specLists[1].tempSpecName : ''

  // 按照后端 BigDecimal 习惯，确保数字类型正确，skuStatus 是 String
  payload.skuList.forEach(sku => {
    sku.sellingPrice = Number(sku.sellingPrice || 0)
    sku.stockNum = Number(sku.stockNum || 0)
    sku.firstCommissionRate =
      sku.firstCommissionRate !== undefined && sku.firstCommissionRate !== null ? Number(sku.firstCommissionRate) : null
    sku.secondCommissionRate =
      sku.secondCommissionRate !== undefined && sku.secondCommissionRate !== null
        ? Number(sku.secondCommissionRate)
        : null
    sku.specInfoList =
      specLists.length > 1
        ? [
            { specName: firstSpecName, specValue: sku.skuName },
            { specName: secondSpecName, specValue: sku.innerSkuName }
          ]
        : [{ specName: firstSpecName, specValue: sku.skuName }]
  })
  // payload.specName = tempSpecName.value

  console.log('提交给后端的最终参数:', payload)

  let apiUrl = 'admin/goods/createSpuInfo'
  if (form.spuCode) {
    apiUrl = 'admin/goods/editSpuInfo'
  }
  await app.request({ api: apiUrl, method: 'post', data: payload })
  ElMessage.success('发布成功')
  setTimeout(() => {
    app.router.close()
  }, 1000)
}

onMounted(() => {
  getCategoryList()
  handleSpecValueChange() // 初始生成一行
  queryDetail()
})
</script>

<style scoped>
.product-edit-container {
  background-color: #f0f2f5;
  min-height: 100vh;
}
.box-card {
  border: none;
  border-radius: 4px;
}
.card-header {
  font-weight: bold;
  border-left: 4px solid #409eff;
  padding-left: 10px;
}

/* 解决问题1：彻底重写图片部分，避免重叠 */
.image-section {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
}
.image-uploader-wrapper {
  width: 100%;
}
.image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.img-preview {
  width: 110px;
  height: 110px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  position: relative;
}
.preview-el-img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.delete-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  color: #f56c6c;
  background: #fff;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
}
.uploader-plus {
  width: 110px;
  height: 110px;
  border: 1px dashed #dcdfe6;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: border-color 0.2s;
}
.uploader-plus:hover {
  border-color: #409eff;
}
.uploader-text {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

/* 规格管理样式 */
.spec-manage-box {
  background-color: #f8f9fb;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #edf0f5;
  margin-bottom: 20px;
}
.spec-header-row,
.spec-values-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.label {
  width: 80px;
  font-weight: 500;
  color: #606266;
}
.tip-inline {
  font-size: 12px;
  color: #909399;
  margin-left: 15px;
}
.values-list {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.spec-value-item {
  display: flex;
  align-items: center;
  width: 180px;
}

.sku-table-wrapper {
  margin-top: 15px;
}
.limit-box {
  margin-left: 20px;
  color: #666;
  font-size: 14px;
}
.mt-20 {
  margin-top: 20px;
}
.ml-10 {
  margin-left: 10px;
}

.form-footer {
  margin-top: 30px;
  padding: 24px;
  background: #fff;
  text-align: center;
  border-radius: 4px;
}

.limit-box {
  margin-left: 20px;
  color: #666;
  font-size: 14px;
}
.address-box {
  padding: 15px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 4px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mt-20 {
  margin-top: 20px;
}
</style>
